import React, { useState } from "react";
import { db } from "@/config/firebase";
import { collection, deleteDoc, doc, getDocs } from "firebase/firestore";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

export default function RosterClean() {
  const [text, setText] = useState("");
  const [status, setStatus] = useState("");

  const apply = async () => {
    setStatus("Bereinige Kader…");
    const allow = new Set(text.split(/\n+/).map(s=>s.trim().toLowerCase()).filter(Boolean));
    const us = await getDocs(collection(db, "users"));
    let removed=0; let kept=0;
    for (const d of us.docs) {
      const u = d.data();
      const key = (u.display_name||u.name||u.email||"").toLowerCase();
      if (!allow.has(key)) { try { await deleteDoc(doc(db, "users", d.id)); removed++; } catch(_){} }
      else kept++;
    }
    setStatus(`Fertig. Behalten: ${kept}, Gelöscht (nur Firestore): ${removed}. Hinweis: Auth-Accounts lösche ich nicht ohne Service Account.`);
  };

  return (
    <div className="pb-28 min-h-screen bg-[#0e0b0c] text-rose-50 px-4 pt-6">
      <h2 className="text-xl font-bold mb-3">Kader bereinigen</h2>
      <Card className="bg-[#1a0d11] border-white/10">
        <CardContent className="pt-4 space-y-3">
          <p className="text-sm">Füge pro Zeile einen erlaubten Anzeigenamen ein (z.B. „Daniel“, „Cosimo“, „Guido“). Alle anderen Firestore‑Einträge werden entfernt.</p>
          <textarea className="w-full h-40 p-2 rounded bg-[#2a1419] border-white/10 text-rose-50" value={text} onChange={e=>setText(e.target.value)} placeholder="Daniel\nCosimo\nGuido" />
          <Button data-testid="roster-apply" onClick={apply} className="bg-[#b40023] hover:bg-[#97001d]">Bereinigen</Button>
          {status && <div className="text-xs text-rose-200/80">{status}</div>}
        </CardContent>
      </Card>
    </div>
  );
}
